import { getRecalculatedYoYAndQoQ } from 'partner360/helpers/financialTable/getRecalculatedYoYAndQoQ'
import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { HP_COMPETITOR_ID, observedFields } from '../constants'

import { getRecalculatedOther } from './getRecalculatedOther'
import { getRecalculatedSellThruAndFYFields } from './getRecalculatedSellThruAndFYFields'
import { getRecalculatedSellThruAndFYFieldsForOthers } from './getRecalculatedSellThruAndFYFieldsForOthers'
import { getRelatedFields } from './getRelatedFields'
import { getUpdatedChildrenData } from './getUpdatedChildrenData'
import { getUpdatedParentData } from './getUpdatedParentData'

interface IGetUpdatedCompetitorData {
  competitors: ISobCompetitor[]
  competitorId: string
  entryId: string
  field: string
  value: number
}

const updateCompetitors = (
  competitors: ISobCompetitor[],
  updatedRows: ISobCompetitor[]
): ISobCompetitor[] => {
  return competitors.map((competitor) => {
    const updatedRow = updatedRows.find(
      (row) => row.EntryId === competitor.EntryId && row.CompetitorID === competitor.CompetitorID
    )
    return updatedRow ? { ...competitor, ...updatedRow } : competitor
  })
}

export const getUpdatedCompetitorData = ({
  competitorId,
  entryId,
  field,
  competitors,
  value,
}: IGetUpdatedCompetitorData) => {
  const item = competitors.find((c) => c.EntryId === entryId && c.CompetitorID === competitorId)
  const hpItem = competitors.find(
    (el) => el.EntryId === entryId && el.CompetitorID === HP_COMPETITOR_ID
  )
  if (!item) {
    return competitors
  }
  const updatedRow = getRelatedFields(field).calcFn({
    item,
    value,
    field,
    hpItem,
  })

  const updatedCompetitors = updateCompetitors(competitors, [updatedRow])

  const updatedSellThruAndFYFields = getRecalculatedSellThruAndFYFields({
    competitors: updatedCompetitors,
    field: field,
  })

  const updatedChildrenData = getUpdatedChildrenData({
    competitors: updatedSellThruAndFYFields,
    competitorId,
    entryId,
    field: field,
    observedFields: observedFields,
  })

  const updatedParentData = getUpdatedParentData({
    competitors: updatedChildrenData,
    competitorId,
    entryId,
    field: field,
    observedFields: observedFields,
  })

  const recalculatedOther = getRecalculatedOther({ competitors: updatedParentData, field })
  const recalculatedOtherSellThruAndFYFields = getRecalculatedSellThruAndFYFieldsForOthers({
    competitors: recalculatedOther,
    field,
  })

  return getRecalculatedYoYAndQoQ<ISobCompetitor>({
    data: recalculatedOtherSellThruAndFYFields,
  })
}
